/**
 * Files handed to an image block by dropping them on the report, held until the
 * block mounts and can upload them.
 *
 * A singleton map rather than a field on the block, for the same reason
 * `preview-cache.ts` exists: the block is report data that gets serialised and
 * sent to the API, and a `File` has no business in that payload.
 */
const pendingFiles = new Map<string, File>();

export const setPendingImageFile = (blockId: string, file: File) => {
    pendingFiles.set(blockId, file);
};

/** Returns the file once, then forgets it — an upload must never repeat. */
export const takePendingImageFile = (blockId: string): File | undefined => {
    const file = pendingFiles.get(blockId);
    pendingFiles.delete(blockId);
    return file;
};
